module.exports = __webpack_public_path__ + "img/Scanvaegt5.9794d589.png";